/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostazureaccountsPostAzureAccountsResult
 */
export interface JumboPostazureaccountsPostAzureAccountsResult {
    /**
     * 
     * @type {string}
     * @memberof JumboPostazureaccountsPostAzureAccountsResult
     */
    tokenID?: string;
}

/**
 * Check if a given object implements the JumboPostazureaccountsPostAzureAccountsResult interface.
 */
export function instanceOfJumboPostazureaccountsPostAzureAccountsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboPostazureaccountsPostAzureAccountsResultFromJSON(json: any): JumboPostazureaccountsPostAzureAccountsResult {
    return JumboPostazureaccountsPostAzureAccountsResultFromJSONTyped(json, false);
}

export function JumboPostazureaccountsPostAzureAccountsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostazureaccountsPostAzureAccountsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenID': !exists(json, 'tokenID') ? undefined : json['tokenID'],
    };
}

export function JumboPostazureaccountsPostAzureAccountsResultToJSON(value?: JumboPostazureaccountsPostAzureAccountsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tokenID': value.tokenID,
    };
}

